import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    standalone: false
})
export class MessageComponent {
    @Input() text: string;
    @Input() messageType = 'status';
    @Input() timestamp: Date;
    @Input() companionName: string;

    constructor() {
    }

}
